import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { MessagePopoverComponent, MessagePopoverButton } from '../message-popover/message-popover.component';
import { HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-access-code-popover',
  templateUrl: './access-code-popover.component.html',
  styleUrls: ['./access-code-popover.component.scss']
})
export class AccessCodePopoverComponent implements OnInit, AfterViewInit {

  @ViewChild('inputAccessCode', { read: ElementRef }) inputAccessCode:ElementRef;

  accessCode: string = ''
  waiting: boolean = false;
  isSuccess: boolean = false;

  constructor(private popoverCtrl: PopoverController, private http: HttpClient) { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    // for andriod keyboard open
    this.inputAccessCode.nativeElement.focus()
  }

  cancel() {
    this.popoverCtrl.dismiss()
  }

  submit() {
    this.waiting = true

    // https://teacher-dev.musictogether.com/_api/v1
    // /accounts/register
    // familyCode is the only variable to post
    const data = {
      'familyCode': this.accessCode
    }
    this.http.post('/accounts/register', data, {observe: 'response'})
            // .pipe(catchError(this.handleError))
            .subscribe((r: any) => {
              this.waiting = false

              if (r.body.status === 400) {
                let errorMessage = r.body.errors[0]
                if (errorMessage == null || errorMessage.length === 0) {
                  errorMessage = 'You have entered an invalid access code. Please try again, making sure to type the code exactly as written.'
                }
                // error, show it
                MessagePopoverComponent.present(this.popoverCtrl, 'Oops!', errorMessage, false, false, [
                  { name: 'Cancel', type: MessagePopoverButton.Type.Cancel, action: () => { this.popoverCtrl.dismiss() } },
                  { name: 'Enter Again', type: MessagePopoverButton.Type.Submit, action: () => { } },
                ])
              } else if (r.body.status === 201) {
                // It worked
                this.isSuccess = true;
                this.waiting = false;
              }
            });
  }

}
